var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('br'),_c('p',[_c('b-alert',{attrs:{"variant":"danger","show":""}},[_vm._v("Path not found: "),_c('b',[_vm._v(_vm._s(_vm.getPath))])])],1),_c('b-button',{attrs:{"block":"","variant":"info","to":"/"}},[_vm._v("Home")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }